export default "__VITE_ASSET__N1l59sXn__"